export default "__VITE_ASSET__pTlQW$iX__"